(function() {
    const DatiUtenteService = function(
        $http,
        CONSTANTS
    ) {
        this.recuperaDominiMfweb = (codiceMito) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.DOMINI.CATEGORIA_MFWEB + codiceMito
            });
        };
        
        this.recuperaClassificazioneUtente = (codiceMito) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.MITO.CLASSIFICAZIONE + codiceMito
            });
        };
        
        this.recuperaDateUltimiAccessi = (idUtente) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.MITO.ULTIMI_ACCESSI + idUtente
            });
        };
        
        this.recuperaStatiRaggiungibili = (codiceMito, idPratica) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.MITO.LISTA_STATI + (codiceMito || '') + '/' + (idPratica || '0')
            });
        };
    };

    DatiUtenteService.$inject = [
        '$http',
        'Mitom_CONSTANTS'
    ];

    angular
        .module('cbl.mitomanager.wa')
        .service('MitomDatiUtenteService', DatiUtenteService);
})();